import React from "react";
import { useKey } from "rooks";
import CornerstoneViewport from "react-cornerstone-viewport";
import CircularProgress, {
  CircularProgressProps,
} from "@mui/material/CircularProgress";
import { Grid, IconButton, Tooltip } from "@mui/material";
import { Typography } from "@mui/material";
import { Container } from "@mui/material";
import { Slider } from "@mui/material";
import { Collapse } from "@mui/material";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { MenuItem } from "@mui/material";
import { FormControl } from "@mui/material";
import { Button } from "@mui/material";
import { Switch } from "@mui/material";
import { Stack } from "@mui/material";
import { Box } from "@mui/material";
import { InputLabel } from "@mui/material";
import { isMobile } from "react-device-detect";
import { OutlinedInput } from "@mui/material";
import { Checkbox } from "@mui/material";
import { ListItemText } from "@mui/material";
import { openViewer } from "../UniversalViewer/useUniversalViewer";
import { useAuthContext } from "../Auth/AuthContext";
import { ExpandMore } from "../../Functions/ScreenOperation/ExpandMore";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import InfoIcon from "@mui/icons-material/Info";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import LaunchOutlinedIcon from "@mui/icons-material/LaunchOutlined";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import { activeTools } from "../../Environment/Config";
import ViewerTools from "./ViewerTools";
import { GetDicoms } from "../../Functions/Dicom/readDicomData";
import { db } from "../../Environment/firebase";
import { useWindowDimensions } from "../../Functions/ScreenOperation/useWindowDimension";
import LookrecImage from "../../Images/lookrec.png";
import { MstaFontFamily } from "../../Functions/Style/MstaFont";
import {
  selectStudy,
  dicomFilesRef,
  extractDicomDataAsSeries,
} from "../../Functions/Dicom/readDicomDataAsArray";
//import './lectureStyles/lecture.css';

const cornerstoneTools = require("cornerstone-tools");

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

type CatalogueViewerServiceType = {
  CatalogueId: string;
  displayAllImage: boolean;
  title: string;
  age: string;
  sex: string;
  modality: string;
  keyImageInfo?: {
    seriesUId: string;
    sopInstanceUId: string;
  };
  handlekeyImageInfoTime?: number;
};

export function CatalogueUniversalViewerService(
  props: CatalogueViewerServiceType
) {
  //const uploaderId = props.uploaderId;
  const CatalogueId = props.CatalogueId;
  const displayAllImage = props.displayAllImage;
  const title = props.title || "タイトル未指定";
  const age = (Math.trunc(parseInt(props.age) / 10) * 10).toString();
  const sex = props.sex;
  //const studyUID = props.studyUID;

  const { userData } = useAuthContext();
  const canOutput = userData?.userStatus === "admin" || userData?.userStatus === "edit";

  const [viewerExpanded, setViewerExpanded] = React.useState(true);
  const { width } = useWindowDimensions();
  //Singleで表示させる画像Indexのリスト番号
  const [activeNumber, setActiveNumber] = React.useState("");
  const [dicomFiles, setDicomFiles] = React.useState<dicomFilesRef[]>([]);
  const [studyUID, setStudyUId] = React.useState("");

  //全画像シリーズの全データ
  const [imageIdslist, setImageIdslist] = React.useState<
    {
      protocol: string;
      seriesNumber: number;
      series: string;
      share: boolean;
    }[]
  >([]); //{seires:str,protocol:str,url:list(str)}のlist

  //一画面で表示させる画像のpathリストのデータセット
  const [imageIds, setImageIds] = React.useState<string[]>([]); //urlのlist

  const [imageInfo, setImageInfo] = React.useState(true);
  const [update, setUpdata] = React.useState(false);
  //表示させる画像の高さ
  const [indexValue, setIndexValue] = React.useState(0);

  const [ViewerActiveTool, setViewerActiveTool] = React.useState("Wwwc");
  const [totalLoadingImage, setTotalLoadingImage] = React.useState(0);
  const [loadingImageIndex, setLoadingImageIndex] = React.useState(0);
  const [showLoading, setShowLoading] = React.useState(false);
  const [judgeViewer, setJudgeViewer] = React.useState(true);
  const [isFinished, setIsFinished] = React.useState(true);
  const intervalRef = React.useRef<NodeJS.Timeout | null>(null);

  const handleSliderChange = (event: Event, newValue: number | number[]) => {
    var gotValue = newValue as number;
    setIndexValue(gotValue - 1);
  };

  const handleMouseDown = (increment: number) => {
    intervalRef.current = setInterval(() => {
      setIndexValue((prev) => {
        if (increment < 0) {
          return Math.max(prev + increment, 0);
        } else {
          return Math.min(prev + increment, imageIds.length - 1);
        }
      });
    }, 100);
  };

  const handleMouseUp = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  const handleImageInfo = () => {
    setImageInfo(!imageInfo);
    setUpdata(update ? false : true);
  };

  const handleInfoButton = (judge: boolean) => {
    if (judge === true) {
      return "contained";
    } else {
      return "outlined";
    }
  };

  const ViewerSize = (data: { sx: string; md: string }) => {
    if (width < 450) {
      return data.sx;
    } else {
      return data.md;
    }
  };

  const extractImageIds = (dicomDataset: dicomFilesRef[], series: string) => {
    var SeriesDicoms = dicomDataset.filter((item) => item.seriesId === series);
    SeriesDicoms.sort(
      (a, b) => parseInt(a.instanceNumber) - parseInt(b.instanceNumber)
    );
    const targetImageIds = SeriesDicoms.map((item) => item.imageId);
    return targetImageIds;
  };

  const getSeriesNumber = (
    dicomDataset: dicomFilesRef[],
    targetSeries: string,
    targetInstance: string
  ) => {
    const foundImage = imageIdslist.find(
      (image) => image.series === targetSeries
    );
    const seriesDicoms = dicomDataset.filter(
      (item) => item.seriesId === targetSeries
    );
    seriesDicoms.sort(
      (a, b) => parseInt(a.instanceNumber) - parseInt(b.instanceNumber)
    );
    const targetImageIds = seriesDicoms.map((item) => item.imageId);
    const firstInstanceNumber = seriesDicoms[0]?.instanceNumber;
    const instanceDicom = seriesDicoms.filter(
      (item, index) => item.instanceId === `${targetInstance}.dcm`
    );
    console.log(instanceDicom);
    try {
      if (instanceDicom.length > 0) {
        var instanceIndex =
          parseInt(instanceDicom[0]?.instanceNumber) -
          parseInt(firstInstanceNumber);
        console.log(instanceIndex);
        setIndexValue(instanceIndex);
      }
    } catch (error: any) {
      console.error("Error:", error.message);
    }
    if (foundImage) {
      var newImageIds = extractImageIds(dicomFiles, foundImage.series);
      setImageIds(newImageIds);
      setActiveNumber(foundImage.series);
    }
    setUpdata(!update);
  };

  const handleViewerImagebyKeyImage = (
    targetSeries: string,
    targetInstance: string
  ) => {
    getSeriesNumber(dicomFiles, targetSeries, targetInstance);
  };

  const handleActiveNumber = (event: SelectChangeEvent<string>) => {
    const series = event.target.value.toString();
    setActiveNumber(series);
    const newImageIds = extractImageIds(dicomFiles, series);
    setImageIds(newImageIds);
    setIndexValue(0);
  };

  const handleScrollEvent = (event: WheelEvent) => {
    const eventDetail: any = event.detail;
    setIndexValue(eventDetail.newImageIdIndex);
  };

  const handleKeyEvent = (event: KeyboardEvent): void => {
    switch (event.key) {
      case "ArrowLeft":
        var newValue = indexValue - 1;
        setIndexValue(Math.max(newValue, 0));
        break;
      case "ArrowRight":
        var newValue = indexValue + 1;
        setIndexValue(Math.min(newValue, imageIds.length - 1));
        break;
      default:
        break;
    }
  };

  useKey(["ArrowLeft", "ArrowRight"], handleKeyEvent);

  React.useEffect(() => {
    if (props.keyImageInfo && dicomFiles.length > 0) {
      handleViewerImagebyKeyImage(
        props.keyImageInfo.seriesUId,
        props.keyImageInfo.sopInstanceUId
      );
    }
  }, [props.handlekeyImageInfoTime]);

  React.useEffect(() => {
    db.collection("dwh")
      .doc(CatalogueId)
      .get()
      .then(async (doc) => {
        const studyUID: string = doc.data()?.studyUId || "";
        setStudyUId(studyUID);
        const serieses: string[] = doc.data()?.Serieses || [""];
        serieses.sort();
        const dicomDatas = await Promise.all(
          serieses.map(async (series) => {
            const dicomData: {
              protocol: string;
              seriesNumber: number;
              series: string;
              share: boolean;
            } = await db
              .collection("dwh")
              .doc(CatalogueId)
              .collection("dicomData")
              .doc(series)
              .get()
              .then((doc) => {
                return {
                  protocol: doc.data()?.protocol,
                  seriesNumber: doc.data()?.seriesNumber,
                  series: series,
                  share: doc.data()?.share,
                };
              });
            return dicomData;
          })
        );
        var dicomDatasComp: {
          protocol: string;
          seriesNumber: number;
          series: string;
          share: boolean;
        }[];

        if (displayAllImage === true) {
          dicomDatasComp = dicomDatas;
        } else {
          dicomDatasComp = dicomDatas.filter(
            (item: {
              protocol: string;
              seriesNumber: number;
              series: string;
              share: boolean;
            }) => item.share === true
          );
        }

        setImageIdslist(dicomDatasComp);
      });
  }, [CatalogueId]);

  React.useEffect(() => {
    setShowLoading(true);

    const getDcmImages = async () => {
      let selectImageIdslist: {
        protocol: string;
        seriesNumber: number;
        series: string;
        share: boolean;
      }[];
      if (displayAllImage === false) {
        selectImageIdslist = imageIdslist.filter((item) => item.share === true);
      } else {
        selectImageIdslist = imageIdslist;
      }
      const firstImageIdsInfo = selectImageIdslist[0];

      let dicomFileBase = await extractDicomDataAsSeries(
        CatalogueId,
        studyUID,
        firstImageIdsInfo.series,
        (input_num) => {
          setTotalLoadingImage((pa_count) => pa_count + input_num);
        },
        () => {
          setLoadingImageIndex((count) => count + 1);
        }
      ).then(async (result) => {
        const firstSeries = firstImageIdsInfo.series;
        const firstImageIds = extractImageIds(result, firstSeries);
        setImageIds(firstImageIds);
        setActiveNumber(firstSeries);
        setShowLoading(false);
        setDicomFiles(result);
        const imageFile = await Promise.all(
          selectImageIdslist.slice(1).map(async (imageIdsInfo) => {
            const imagesOfSeries = await extractDicomDataAsSeries(
              CatalogueId,
              studyUID,
              imageIdsInfo.series,
              (input_num) => {
                setTotalLoadingImage((pa_count) => pa_count + input_num);
              },
              () => {
                setLoadingImageIndex((count) => count + 1);
              }
            );
            setDicomFiles((prevFiles) => [...prevFiles, ...imagesOfSeries]);
            return imagesOfSeries;
          })
        );
        result.push(...imageFile.flat());
        return result;
      });

      return dicomFileBase;
    };

    if (imageIdslist.length > 0) {
      getDcmImages().then((imageFilelist) => {
        setDicomFiles(imageFilelist);
        setJudgeViewer(false);
        setIsFinished(false);
      });
    }
  }, [imageIdslist]);

  return (
    <div>
      <Container maxWidth="lg" disableGutters sx={{ py: 2 }}>
        <Grid spacing={3} sx={{ mt: 1 }}>
          <Grid item xs={12} sm={6} style={{ background: "white" }}>
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="flex-end"
              sx={{ display: "flex" }}
            >
              <Box display="flex" alignItems="center">
                <Typography
                  variant="h5"
                  color="text.secondary"
                  textAlign="left"
                >
                  Viewer
                </Typography>
                <ExpandMore
                  expand={viewerExpanded}
                  onClick={() => {
                    setViewerExpanded(!viewerExpanded);
                  }}
                  aria-expanded={viewerExpanded}
                  aria-label="show more"
                >
                  <ExpandMoreIcon
                    sx={{ color: "text.secondary", fontSize: 30 }}
                  />
                </ExpandMore>
              </Box>
              <Typography
                sx={{
                  color: "#72777C",
                  fontSize: {
                    xs: 12,
                    sm: 14,
                  },
                  fontFamily: "Arial",
                  mb: 0.3,
                }}
              >
                ※頭部の画像は匿名加工しております
              </Typography>
            </Grid>
            <Collapse in={viewerExpanded} timeout="auto" unmountOnExit>
              <div style={{ position: "relative" }}>
                {isFinished && !showLoading ? (
                  <div style={{ position: "absolute", zIndex: 1 }}>
                    <Typography
                      sx={{ color: "yellow", ml: { xs: 4, sm: 5 } }}
                    >
                      {loadingImageIndex}/{totalLoadingImage}
                    </Typography>
                  </div>
                ) : (
                  <></>
                )}
                {imageIds.length > 0 && showLoading === false ? (
                  <Box
                    sx={{
                      display: "flex",
                      width: "100%",
                      height: { sx: "30vh", md: "60vh" },
                      bgcolor: "#ECF5FA",
                    }}
                  >
                    <Box
                      sx={{
                        m: 0,
                        p: 0,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <ViewerTools
                        children={[]}
                        handleActiveTool={(tool) => setViewerActiveTool(tool)}
                      />
                      <Tooltip title="画像情報" placement="left">
                        <IconButton
                          sx={{ p: 0.5, pb: 1 }}
                          onClick={handleImageInfo}
                        >
                          {imageInfo ? (
                            <InfoIcon
                              sx={{
                                fontSize: { xs: 18, sm: 23, md: 25 },
                                color: "#2278CF",
                              }}
                            />
                          ) : (
                            <InfoOutlinedIcon
                              sx={{
                                fontSize: { xs: 18, sm: 23, md: 25 },
                                color: "#2278CF",
                              }}
                            />
                          )}
                        </IconButton>
                      </Tooltip>
                    </Box>
                    <Box sx={{ flexGrow: 1, m: 0, p: 0 }}>
                      <CornerstoneViewport
                        tools={activeTools}
                        imageIds={imageIds}
                        imageIdIndex={indexValue}
                        activeTool={ViewerActiveTool}
                        isOverlayVisible={imageInfo}
                        eventListeners={[
                          {
                            target: "cornerstone",
                            eventName: cornerstoneTools.EVENTS.STACK_SCROLL,
                            handler: handleScrollEvent,
                          },
                        ]}
                        className="conerstone-viewport"
                        style={{
                          width: "100%",
                          height: ViewerSize({ sx: "30vh", md: "60vh" }),
                        }}
                      />
                    </Box>
                  </Box>
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      width: "100%",
                      height: { sx: "30vh", md: "60vh" },
                      bgcolor: "#ECF5FA",
                    }}
                  >
                    <Box
                      sx={{
                        m: 0,
                        p: 0,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <ViewerTools children={[]} handleActiveTool={() => {}} />
                      <Tooltip title="画像情報" placement="left">
                        <IconButton sx={{ p: 0.5, pb: 1 }}>
                          {imageInfo ? (
                            <InfoIcon
                              sx={{
                                fontSize: { xs: 20, sm: 23, md: 25 },
                                color: "#2278CF",
                              }}
                            />
                          ) : (
                            <InfoOutlinedIcon
                              sx={{
                                fontSize: { xs: 20, sm: 23, md: 25 },
                                color: "#2278CF",
                              }}
                            />
                          )}
                        </IconButton>
                      </Tooltip>
                    </Box>
                    <Box sx={{ flexGrow: 1, m: 0, p: 0 }}>
                      <Grid
                        sx={{
                          width: "100%",
                          height: ViewerSize({ sx: "30vh", md: "60vh" }),
                          alignItems: "center",
                          justifyContent: "space-between",
                          background: "black",
                        }}
                      >
                        {showLoading ? (
                          <Grid
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                          >
                            <Typography
                              variant="h3"
                              gutterBottom
                              sx={{
                                color: "white",
                                fontSize: { xs: 28, sm: 36, md: 40 },
                              }}
                            >
                              {loadingImageIndex}/{totalLoadingImage} Loading...
                            </Typography>
                          </Grid>
                        ) : (
                          <div></div>
                        )}
                      </Grid>
                    </Box>
                  </Box>
                )}
              </div>
              <Grid
                container
                sx={{ rowGap: 1, columnGap: 3, mt: 1 }}
                paddingLeft={{xs: 3, md: 4.5}}
                alignItems="center"
                justifyContent={{
                  xs: "center",
                  sm: "center",
                  md: "center",
                  lg: "center",
                }}
                display="flex"
                flexDirection={{ xs: "column", sm: "row" }}
              >
                <FormControl sx={{ my: 1, width: 300 }}>
                  <InputLabel
                    id="demo-simple-select-label"
                    sx={{ fontSize: 20 }}
                  >
                    {props.modality}
                  </InputLabel>
                  <Select
                    value={activeNumber}
                    defaultValue={""}
                    onChange={handleActiveNumber}
                    displayEmpty
                    inputProps={{ "aria-label": "Without label" }}
                    label={props.modality}
                    labelId="demo-simple-select-label"
                    sx={{ borderRadius: 2, height: 50 }}
                  >
                    {imageIdslist.map((dicomData, index) => {
                      return (
                        <MenuItem
                          key={index}
                          value={dicomData.series}
                          disabled={
                            dicomFiles.findIndex(
                              ({ seriesId }) => seriesId === dicomData.series
                            ) === -1
                          }
                        >
                          {dicomData.protocol}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
                <Button
                  variant="outlined"
                  disabled={judgeViewer}
                  onClick={() => openViewer(dicomFiles, title, age, sex, !canOutput)}
                  sx={{
                    my: 1,
                    borderRadius: 2,
                    height: 50,
                    width: { xs: 300, sm: "auto" },
                  }}
                >
                  <Grid
                    display="flex"
                    alignItems="center"
                    justifyItems="center"
                    gap={2}
                  >
                    <Typography
                      component="div"
                      variant="body1"
                      fontFamily={MstaFontFamily}
                    >
                      Universal Viewer
                    </Typography>
                    <LaunchOutlinedIcon />
                  </Grid>
                </Button>
                <Box
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                >
                  <Typography sx={{ fontSize: 14 }}>画像スクロール</Typography>
                  <Box
                    gap={1}
                    alignItems="center"
                    justifyContent="center"
                    display="flex"
                    flexDirection="row"
                    sx={{ mt: 1, mb: 0.5 }}
                  >
                    <Button
                      variant="outlined"
                      sx={{ height: 24, width: 60 }}
                      onClick={() =>
                        setIndexValue((prev) => Math.max(prev - 1, 0))
                      }
                      onMouseDown={() => handleMouseDown(-1)}
                      onMouseUp={handleMouseUp}
                      onMouseLeave={handleMouseUp}
                    >
                      <ArrowRightAltIcon sx={{ transform: "rotate(180deg)" }} />
                    </Button>
                    <Button
                      variant="outlined"
                      sx={{ height: 24, width: 60 }}
                      onClick={() =>
                        setIndexValue((prev) =>
                          Math.min(prev + 1, imageIds.length - 1)
                        )
                      }
                      onMouseDown={() => handleMouseDown(1)}
                      onMouseUp={handleMouseUp}
                      onMouseLeave={handleMouseUp}
                    >
                      <ArrowRightAltIcon />
                    </Button>
                  </Box>
                </Box>
                {/* <Box width={{ sx: 100, md: 200 }}>
                  <Typography id="input-slider" gutterBottom>
                    画像スクロール
                  </Typography>
                  <Slider
                    value={indexValue + 1}
                    onChange={handleSliderChange}
                    aria-label="Default"
                    valueLabelDisplay="auto"
                    min={1}
                    max={imageIds.length}
                  />
                </Box> */}
              </Grid>
              {/* <Grid mt={2}>
                <Button
                  variant="outlined"
                  disabled={judgeViewer}
                  onClick={() => openViewer(dicomFiles, title, age, sex, !canOutput)}
                >
                  <Grid
                    display="flex"
                    alignItems="center"
                    justifyItems="center"
                    gap={2}
                  >
                    <img
                      src={LookrecImage}
                      width={25}
                      height={25}
                      alt="Lookrec"
                    ></img>
                    <Typography
                      component="div"
                      variant="body1"
                      fontFamily={MstaFontFamily}
                    >
                      {" "}
                      Universal Viewerで開く
                    </Typography>
                  </Grid>
                </Button>
              </Grid> */}
            </Collapse>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}
